<ng-container *transloco="let t">
  @let scrollHeaderTitle = scrollHeaderTitle$ | async;
  @let headerTitle = headerTitle$ | async;
  <header class="bg-full-white" tuiHeader [scrollHeaderTitle]="scrollHeaderTitle">
    <h1 tuiTitle>
      {{ headerTitle }}
      @if (headerSubtitle) {
        <span tuiSubtitle>{{ headerSubtitle }}</span>
      }
    </h1>
  </header>
  <nav
    class="sticky flex w-full flex-col items-stretch justify-start gap-3 py-2! sm:flex-row sm:items-center"
    tuiNavigationNav>
    <pxc-filter-bar
      class="w-full"
      data-testid="filter-bar"
      [searchPlaceholder]="t('Rechercher une séquence par mot clé, date ou patient ...')" />

    <div class="flex items-center gap-3 self-end sm:self-center">
      <pxc-sequence-preview-mode-segmented
        [previewMode]="sequencePreviewMode"
        (previewModeChanged)="setPreviewMode($event)" />

      @if (hasLicenseWriteAccess$ | async) {
        <button data-testid="add-sequence" tuiButton type="button" (click)="addSequence()">
          {{ t('Ajouter') }}
        </button>
      }
    </div>
  </nav>
  @if (isCollectionLoaded$ | async) {
    <pxc-sequence-list
      data-testid="sequence-list"
      [actions]="actions"
      [mode]="sequencePreviewMode"
      (sequenceMediaClicked)="openSequenceMediaGallery($event)" />
  } @else {
    <pxc-loader class="my-5" data-testid="loading">
      {{ t('Récupération de vos séquences en cours ...') }}
    </pxc-loader>
  }
</ng-container>
